import "./widgets-core4.css";
import { watch as x, getCurrentScope as K, onScopeDispose as q, unref as L, ref as p, defineComponent as J, useSlots as Q, computed as y, onMounted as X, openBlock as T, createElementBlock as E, createVNode as Y, createBlock as Z, Teleport as ee, mergeProps as te, createElementVNode as _, renderSlot as oe, normalizeClass as ae, createCommentVNode as re, h as S } from "vue";
import { u as $ } from "./chunks/index.CIpUD9Rm.js";
import { u as le } from "./chunks/useTheme.L4REnSCw.js";
import { _ as ne } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
function z(t) {
  return t === null ? null : t.scrollHeight > t.clientHeight ? t : z(t.parentNode);
}
function I(t) {
  return K() ? (q(t), !0) : !1;
}
const ie = typeof window < "u", ue = (t) => typeof t == "string", W = () => {
};
function R(t) {
  var a;
  const e = L(t);
  return (a = e == null ? void 0 : e.$el) != null ? a : e;
}
const C = ie ? window : void 0;
function N(...t) {
  let a, e, o, i;
  if (ue(t[0]) ? ([e, o, i] = t, a = C) : [a, e, o, i] = t, !a)
    return W;
  let l = W;
  const r = x(() => L(a), (c) => {
    l(), c && (c.addEventListener(e, o, i), l = () => {
      c.removeEventListener(e, o, i), l = W;
    });
  }, { immediate: !0, flush: "post" }), s = () => {
    r(), l();
  };
  return I(s), s;
}
var P = Object.getOwnPropertySymbols, se = Object.prototype.hasOwnProperty, ce = Object.prototype.propertyIsEnumerable, pe = (t, a) => {
  var e = {};
  for (var o in t)
    se.call(t, o) && a.indexOf(o) < 0 && (e[o] = t[o]);
  if (t != null && P)
    for (var o of P(t))
      a.indexOf(o) < 0 && ce.call(t, o) && (e[o] = t[o]);
  return e;
};
function de(t, a, e = {}) {
  const o = e, { window: i = C } = o, l = pe(o, ["window"]);
  let r;
  const s = i && "ResizeObserver" in i, c = () => {
    r && (r.disconnect(), r = void 0);
  }, d = x(() => R(t), (u) => {
    c(), s && i && u && (r = new i.ResizeObserver(a), r.observe(u, l));
  }, { immediate: !0, flush: "post" }), f = () => {
    c(), d();
  };
  return I(f), {
    isSupported: s,
    stop: f
  };
}
var B;
(function(t) {
  t.UP = "UP", t.RIGHT = "RIGHT", t.DOWN = "DOWN", t.LEFT = "LEFT", t.NONE = "NONE";
})(B || (B = {}));
function H(t) {
  const a = p(0), e = p(0), o = p(0), i = p(0), l = p(0), r = p(0), s = p(0), c = p(0);
  function d() {
    const f = R(t);
    if (!f) {
      a.value = 0, e.value = 0, o.value = 0, i.value = 0, l.value = 0, r.value = 0, s.value = 0, c.value = 0;
      return;
    }
    const u = f.getBoundingClientRect();
    a.value = u.height, e.value = u.bottom, o.value = u.left, i.value = u.right, l.value = u.top, r.value = u.width, s.value = u.x, c.value = u.y;
  }
  return N("scroll", d, !0), N(window, "resize", d, !0), de(
    t,
    d
  ), {
    height: a,
    bottom: e,
    left: o,
    right: i,
    top: l,
    width: r,
    x: s,
    y: c,
    update: d
  };
}
const fe = { class: "inner" }, ve = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    mode: { default: "hover" },
    modelValue: { type: Boolean, default: !0 },
    placement: { default: "top" },
    minWidth: { default: 0 },
    maxWidth: { default: 0 },
    nowrap: { type: Boolean, default: !0 },
    callbackHide: { type: Function, default: void 0 },
    disabled: { type: Boolean, default: !1 },
    zIndexTooltip: { default: "9999" },
    colorScheme: { default: "info" },
    container: { default: "body" }
  },
  emits: [
    "visible"
  ],
  setup(t, { emit: a }) {
    const e = t, o = a, i = Q(), l = p(!1), r = p(), s = p(), c = le(), {
      top: d,
      left: f,
      bottom: u,
      right: k,
      width: M,
      height: V,
      update: F
    } = H(r), {
      width: g,
      height: b
    } = H(s), j = y(() => {
      switch (e.placement) {
        case "top":
        case "bottom":
          return f.value + (M.value - g.value) / 2;
        case "top-start":
        case "bottom-start":
          return f.value;
        case "top-end":
        case "bottom-end":
          return k.value - g.value;
        case "left":
          return f.value - g.value;
        case "right":
          return k.value;
        default:
          return 0;
      }
    }), D = y(() => {
      switch (e.placement) {
        case "top":
          return d.value - b.value;
        case "top-start":
        case "top-end":
          return d.value - b.value;
        case "bottom":
          return u.value;
        case "bottom-start":
        case "bottom-end":
          return u.value;
        case "left":
        case "right":
          return d.value + (V.value - b.value) / 2;
        default:
          return 0;
      }
    }), A = y(() => ({
      "border-radius": c.borderRadius,
      left: `${j.value}px`,
      top: `${D.value}px`,
      "z-index": e.zIndexTooltip,
      "white-space": e.nowrap ? "nowrap" : "normal",
      "min-width": e.minWidth > 0 ? `${e.minWidth}px` : "auto",
      "max-width": e.maxWidth > 0 ? `${e.maxWidth}px` : "none"
    }));
    function v() {
      l.value || (l.value = !0, F(), o("visible", !0));
    }
    function m() {
      l.value && (l.value = !1, o("visible", !1));
    }
    function w(n) {
      const O = e.mode === "hover" && n.type === "mouseleave", U = e.mode === "click" && n.type === "click" && r.value && !r.value.contains(n.target);
      (O || U) && m();
    }
    function h(n) {
      if (e.mode === "hover") {
        n.type === "mouseenter" && v();
        return;
      }
      e.mode === "click" && n.type === "click" && (l.value ? m() : v());
    }
    x(() => e.modelValue, (n) => {
      n && e.mode === "manual" ? v() : !n && (e.mode === "manual" || e.mode === "click") && m();
    }), X(() => {
      if (e.mode === "manual" && e.modelValue && v(), $(document, "click", w), r.value) {
        const n = z(r.value);
        n && $(n, "scroll", m);
      }
    });
    const G = () => {
      const n = e.disabled ? {} : {
        type: "button",
        onMouseenter: h,
        onFocusin: h,
        onMouseleave: w,
        onFocusout: w,
        onClick: h,
        onKeypress: h
      };
      return S(
        e.disabled ? "div" : "button",
        {
          ...n,
          class: [
            "trigger",
            { "trigger--disabled": e.disabled }
          ],
          "data-testid": "tooltipTrigger"
        },
        S(
          "div",
          { "data-testid": "triggerWrapper" },
          i.trigger()
        )
      );
    };
    return (n, O) => (T(), E("div", {
      ref_key: "tooltipWrapper",
      ref: r,
      "data-testid": "tooltipWrapper"
    }, [
      Y(G),
      (T(), Z(ee, {
        to: e.container
      }, [
        l.value ? (T(), E("div", te({
          key: 0,
          ref_key: "tooltipElement",
          ref: s,
          "data-testid": "tooltipElement",
          class: `tooltip ${e.placement} ${e.colorScheme}`,
          style: A.value
        }, n.$attrs), [
          _("div", fe, [
            oe(n.$slots, "tooltip", {}, void 0, !0)
          ]),
          _("div", {
            class: ae(`tooltip-arrow ${e.placement}`)
          }, null, 2)
        ], 16)) : re("", !0)
      ], 8, ["to"]))
    ], 512));
  }
}), ye = /* @__PURE__ */ ne(ve, [["__scopeId", "data-v-7ac1b24e"]]);
export {
  ye as default,
  z as g
};
//# sourceMappingURL=widgets-core.es5.js.map
